// parseHoroscopeToSections.js (เวอร์ชันแก้ไขให้แยก "คำแนะนำสำหรับลัคนา" และ "คำแนะนำด้าน" ชัดเจน)

function normalize(text = "") {
  return String(text)
    .replace(/\r\n/g, "\n")
    // ปรับโคลอนเต็ม/ครึ่งเป็นมาตรฐาน
    .replace(/[：﹕︓﹔]/g, ":")
    // ตัด space ก่อนขึ้นบรรทัดใหม่
    .replace(/[ \t]+\n/g, "\n")
    // ย่อบรรทัดว่างยาว ๆ
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

// === Header หลัก (ยึดต้นบรรทัดเสมอ) ===
/*const H_WORK = String.raw`^(?:💼\s*):?\s*`;
const H_LOVE = String.raw`^(?:💖\s*):?\s*`;
const H_FIN  = String.raw`^(?:💰\s*):?\s*`;
const H_HEAL = String.raw`^(?:🧘\s*):?\s*`;
const H_LUCK = String.raw`^(?:🔢\s*)?เลขนำโชค\s*:?\s*`;*/
const H_WORK = String.raw`^(?:💼\s*)? การงาน\s*:?\s*`;
const H_LOVE = String.raw`^(?:💖\s*)? ความรัก\s*:?\s*`;
const H_FIN  = String.raw`^(?:💰\s*)? การเงิน\s*:?\s*`;
const H_HEAL = String.raw`^(?:🧘\s*)? สุขภาพ\s*:?\s*`;
const H_LUCK = String.raw`^(?:🔢\s*)? เลขนำโชค\s*:?\s*`;
const STOP_HEADERS = [H_WORK, H_LOVE, H_FIN, H_HEAL, H_LUCK];

function findNextHeaderIndex(text, headerPatterns, startIndex) {
  const slice = text.slice(startIndex);
  let min = -1;
  for (const p of headerPatterns) {
    const re = new RegExp(p, "m");
    const m = re.exec(slice);
    if (m) {
      const idx = startIndex + m.index;
      if (min === -1 || idx < min) min = idx;
    }
  }
  return min;
}

function sliceSection(text, headPattern, stopPatterns) {
  const re = new RegExp(headPattern, "m");
  const m = re.exec(text);
  if (!m) return "";
  const sectionStart = m.index + m[0].length;
  const nextIdx = findNextHeaderIndex(text, stopPatterns, sectionStart);
  const end = nextIdx === -1 ? text.length : nextIdx;
  return text.slice(sectionStart, end).trim();
}

// ===== กติกา “คำแนะนำ”: ยึดต้นบรรทัดเสมอ =====
// 1) ภาพรวม: “คำแนะนำสำหรับลัคนาราศี …” หรือ “คำแนะนำสำหรับลัคนา …”
const TIP_GENERAL_LINE = String.raw`^คำแนะนำสำหรับ(?:ลัคนาราศี|ลัคนา)[^\n]*:\s*`;

// 2) เฉพาะหัวข้อ: ให้เจาะจงก่อน “คำแนะนำด้าน” กว้าง
const TIP_WORK_LINE   = String.raw`^คำแนะนำด้านการงาน\s*:?\s*`;
const TIP_LOVE_LINE   = String.raw`^คำแนะนำด้านความรัก\s*:?\s*`;
const TIP_FIN_LINE    = String.raw`^คำแนะนำด้านการเงิน\s*:?\s*`;
const TIP_HEAL_LINE   = String.raw`^คำแนะนำด้านสุขภาพ\s*:?\s*`;

// 3) Fallback ภายในแต่ละ section: “คำแนะนำด้าน …” แบบกว้าง (ถ้าไม่มีแบบเจาะจง)
//   - ใช้เฉพาะภายใน block ของหัวข้อเท่านั้น เพื่อไม่ให้ไปชนของหัวข้ออื่น
const TIP_ANY_LINE    = String.raw`^คำแนะนำด้าน[^\n]*:\s*`;

// แยก body/tip จาก block ของหัวข้อ โดย “labelCandidates” เรียงลำดับความสำคัญ
function splitBodyAndTip(blockText, labelCandidates) {
  if (!blockText) return { body: "", tip: "" };
  // หา match แรกสุด โดยต้อง “ต้นบรรทัด” เท่านั้น (m flag)
  let found = null;
  let foundIdx = -1;

  for (const pat of labelCandidates) {
    const re = new RegExp(pat, "m");
    const m = re.exec(blockText);
    if (m) {
      // เลือกตำแหน่งที่ซ้ายสุดใน block
      if (foundIdx === -1 || m.index < foundIdx) {
        found = m;
        foundIdx = m.index;
      }
    }
  }

  if (!found) return { body: blockText.trim(), tip: "" };

  const tipStart = found.index + found[0].length;
  const body = blockText.slice(0, found.index).trim();
  const tip  = blockText.slice(tipStart).trim();
  return { body, tip };
}

function stripBrandHeader(intro) {
  const lines = intro.split("\n").map((s) => s.trim());
  if (lines[0] && /^มหาลัคนาพลัส\b/i.test(lines[0])) {
    return lines.slice(1).join("\n").trim();
  }
  return intro;
}

function extractLuckyNumbers(text) {
  const re = /^(?:🔢\s*)?เลขนำโชค[:]\s*([\d\s,–-]+)\s*$/m;
  const m = re.exec(text);
  if (!m) return [];
  return m[1]
    .split(/[,\s–-]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

// ภาพรวม = ช่วงก่อนหัวข้อแรก + ดึง "คำแนะนำสำหรับลัคนา..." เฉพาะต้นบรรทัด
function extractGeneral(text) {
  const firstHeaderIdx = findNextHeaderIndex(text, STOP_HEADERS, 0);
  const rawIntro = firstHeaderIdx === -1 ? text.trim() : text.slice(0, firstHeaderIdx).trim();

  // regex จับบรรทัด "คำแนะนำสำหรับลัคนาราศี..." หรือ "คำแนะนำสำหรับลัคนา..."
  const re = new RegExp(
    String.raw`^คำแนะนำสำหรับ(?:ลัคนาราศี|ลัคนา)[^\n]*:\s*(.*)$`,
    "m"
  );
  const m = re.exec(text);

  // ลบ "คำแนะนำสำหรับลัคนา…" ออกจาก intro
  let introBody = stripBrandHeader(rawIntro);
  if (m) {
    // เอาเฉพาะก่อนคำแนะนำ
    introBody = introBody.replace(m[0], "").trim();
  }

  const tip = m ? m[1].trim() : "";

  return { body: introBody, tip };
}


export function parseHoroscopeToSections(horoscopeText) {
  const raw = normalize(horoscopeText);
  const luckyNumbers = extractLuckyNumbers(raw);

  // ภาพรวม
  const { body: generalBody, tip: generalTip } = extractGeneral(raw);

  // ตัดแต่ละหัวข้อ
  const workBlock    = sliceSection(raw, H_WORK, STOP_HEADERS);
  const loveBlock    = sliceSection(raw, H_LOVE, STOP_HEADERS);
  const financeBlock = sliceSection(raw, H_FIN,  STOP_HEADERS);
  const healthBlock  = sliceSection(raw, H_HEAL, STOP_HEADERS);

  // แยก body/tip: ให้ “label เฉพาะหัวข้อ” มาก่อน “คำแนะนำด้าน …” แบบกว้าง
  const { body: workBody,   tip: workTip }    = splitBodyAndTip(workBlock,   [TIP_WORK_LINE,  TIP_ANY_LINE]);
  const { body: loveBody,   tip: loveTip }    = splitBodyAndTip(loveBlock,   [TIP_LOVE_LINE,  TIP_ANY_LINE]);
  const { body: financeBody,tip: financeTip } = splitBodyAndTip(financeBlock,[TIP_FIN_LINE,   TIP_ANY_LINE]);
  const { body: healthBody, tip: healthTip }  = splitBodyAndTip(healthBlock, [TIP_HEAL_LINE,  TIP_ANY_LINE]);

  return {
    sections: {
      general: { title: "ภาพรวม",  body: generalBody || "", tipTitle: "คำแนะนำ",                 tip: generalTip || "" },
      love:    { title: "ความรัก",  body: loveBody     || "", tipTitle: "คำแนะนำด้านความรัก",   tip: loveTip     || "" },
      finance: { title: "การเงิน",  body: financeBody  || "", tipTitle: "คำแนะนำด้านการเงิน",   tip: financeTip  || "" },
      health:  { title: "สุขภาพ",   body: healthBody   || "", tipTitle: "คำแนะนำด้านสุขภาพ",    tip: healthTip   || "" },
    },
    luckyNumbers
  };
}
